enum OnboardingPageRouteEnum {
  Onboarding = '/onboarding',
  AutoActivation = `${OnboardingPageRouteEnum.Onboarding}/activate/auto/:hash?`,
}

export default OnboardingPageRouteEnum;
